export const RecaptchaSize = {
  DefaultWidthInPx: 304,
  DefaultHeightInPx: 78,
};
